import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { PREFERENCE } from '../../modules/UserPreferences/const/preferences';
import { DISTANCE_UNIT } from '../../consts/distance-units';
import { convertDistanceUnits } from '../../utils/distance';
import { SharedReduxState } from '../../reducers/types';

interface Props {
  distance: number;
  units?: DISTANCE_UNIT;
}

export const DistanceView = ({ distance, units = DISTANCE_UNIT.MI }: Props) => {
  const distanceUnits = useSelector(({ userPreferences }: SharedReduxState) =>
    userPreferences ? userPreferences[PREFERENCE.DISTANCE_UNIT] : DISTANCE_UNIT.MI
  );

  const convertedValue = useMemo(() => {
    return convertDistanceUnits(
      distance,
      units,
      distanceUnits,
      { showUnits: true, roundValue: false }
    );
  }, [distanceUnits, distance, units]);

  return <span data-test-id='distance-view'>{convertedValue}</span>;
};

export default DistanceView;
